// extracted by mini-css-extract-plugin
export default {"header":"Comments_header__98j9L","description":"Comments_description__xGNRr","comments":"Comments_comments__XkARZ","comment":"Comments_comment__Z4-Cn"};